import { render, staticRenderFns } from "./WallGiftRegistryBlockItemSettings.vue?vue&type=template&id=c1e425c4"
import script from "./WallGiftRegistryBlockItemSettings.vue?vue&type=script&lang=js"
export * from "./WallGiftRegistryBlockItemSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports